import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuQuantumSmallIcon extends BaseIcon {
  getChildren = () => [
    <g transform="rotate(-60 1230.73791 -523.8646)">
      <path fill="#e45785"
            d="M158.8-1324.7c-2 0-3.6 3.5-3.6 7.8s1.6 7.8 3.5 7.8c2 0 3.6-3.5 3.6-7.8s-1.6-7.8-3.5-7.8"/>
    </g>,
    <path fill="#e45785"
          d="M10.2 11.8c-1.6.9-3.2 1.6-4.6 1.9C6.2 15.1 7 16 8 16c1.5 0 2.7-2 3.2-4.9-.3.3-.7.5-1 .7zM5.8 4.2c1.6-1 3.2-1.6 4.7-1.9C9.8.9 9 0 8 0 6.5 0 5.3 2 4.8 4.9c.3-.3.7-.5 1-.7z"/>,
    <path fill="#ffb74b"
          d="M9.8 4.9c1.5.9 2.8 1.9 3.7 2.9.2-.3.4-.5.6-.8.9-1.3 1.2-2.4.8-3.1-.4-.6-1.3-.9-2.4-.9-1.2 0-2.7.3-4.3 1.1.5.2 1 .5 1.6.8zM6.2 11.1c-1.5-.9-2.8-1.9-3.7-2.9-.2.2-.4.5-.6.7C1 10.2.7 11.3 1.1 12c.7 1.2 3.4 1.3 6.7-.2-.5-.1-1-.4-1.6-.7z"/>,
    <path fill="#cc1e46" d="M10.8 12.8c.2-.5.3-1.1.4-1.7-.3.2-.7.5-1.1.7-.4.2-.7.4-1.1.6.7.2 1.3.3 1.8.4z"/>,
    <path
        d="M13.4 7.9c-.9-1-2.2-2.1-3.7-2.9-.5-.4-1-.7-1.6-.9-.5.3-1.1.6-1.8.9-1.5.9-2.8 2-3.7 3.1.9 1 2.2 2.1 3.7 2.9.5.3 1.1.6 1.6.8.5-.2 1.1-.5 1.8-.8 1.5-.9 2.8-2 3.7-3.1z"
        fill="#e43608"/>,
    <path fill="#cc1e46" d="M4.8 4.9c.3-.2.7-.5 1.1-.7.3-.2.6-.4 1-.6-.6-.2-1.2-.3-1.7-.4-.2.5-.3 1-.4 1.7z"/>
    ]
  getViewBox = () => '0 0 16 16'
}
